import { Chip } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import dayjs from "dayjs";
import { badgeChipSx } from "../../CurriculumManagementAdmin/components/buttonStyles";
import { notAttendedChipSx } from "./styles";

/**
 * The badge an agent earns by attending a training — the same green chip the admin page shows on
 * its agent-attendance table, so a badge looks identical from either side.
 */
export const BadgeChip = ({ training, maxWidth }) => (
	<Chip
		icon={<WorkspacePremiumIcon />}
		label={training.title}
		size="small"
		title={`${training.title} — ${training.curriculumTitle}`}
		sx={{ ...badgeChipSx, cursor: "inherit", ...(maxWidth ? { maxWidth } : null) }}
	/>
);

/**
 * Whether the agent sat in a session, dated when they did. Used wherever a training is listed
 * without room for the badge itself.
 */
export const AttendanceChip = ({ attended, attendedAt }) =>
	attended ? (
		<Chip
			icon={<WorkspacePremiumIcon />}
			label={attendedAt ? `Attended · ${dayjs(attendedAt).format("MMM D, YYYY")}` : "Attended"}
			size="small"
			sx={{ ...badgeChipSx, cursor: "inherit", maxWidth: "none" }}
		/>
	) : (
		<Chip label="Not attended" size="small" sx={notAttendedChipSx} />
	);
